import { render, staticRenderFns } from "./mUserSelector.vue?vue&type=template&id=08ddc2e7"
import script from "./mUserSelector.vue?vue&type=script&lang=ts"
export * from "./mUserSelector.vue?vue&type=script&lang=ts"
import style0 from "./mUserSelector.vue?vue&type=style&index=0&id=08ddc2e7&prod&lang=less"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports